<div>
    <hub-modal-header headerText="{{ 'bikeshop.modal.update_job_card.quote_options' | translate }}"
        [activeModal]="activeModal"></hub-modal-header>
</div>
<div class="modal-content-container">

    <div>
        <div class="header-container">
            <div class="page-header">
                <!-- {{ "bikeshop.modal.update_job_card.quote_options" | translate }} -->
            </div>
            <div style="margin-left: auto;margin-bottom: 8px;">
                <hub-button [text]="'bikeshop.modal.update_job_card.add_new_option' | translate" [style]="'secondary'"
                    [size]="'lg'" (buttonClick)="openNewOptionContainer()"></hub-button>
            </div>
        </div>

        <div class="no-quote-options" *ngIf="!busy && !showAddNew && (!invoiceOptions || invoiceOptions.length === 0)">
            {{ 'bikeshop.modal.update_job_card.no_quote_options' | translate }}
        </div>
        <div class="quote-options-info"
            *ngIf="!busy && !showAddNew && (!invoiceOptions || invoiceOptions.length === 0)">
            {{ 'bikeshop.modal.update_job_card.quote_options_info' | translate }}
        </div>

        <div class="new-quote-container" *ngIf="showAddNew">
            <div class="row margin-top-16">
                <div class="col-md-4 label"
                    [ngClass]="{'red': newQuoteOption.optionName === null || newQuoteOption.optionName.length === 0}">
                    *{{ 'bikeshop.modal.update_job_card.option_name' | translate }}
                </div>
                <div class="col-md-4 value">
                    <input type="text" pInputText [(ngModel)]="newQuoteOption.optionName" />
                </div>
            </div>

            <div class="row margin-top-16">
                <div class="col-md-4 label">
                    {{ 'bikeshop.modal.update_job_card.option_description' | translate }}
                </div>
                <div class="col-md-8 value">
                    <input type="text" pInputText [(ngModel)]="newQuoteOption.optionDescription" />
                </div>
            </div>

            <div class="row margin-top-16" *ngIf="!newQuoteOption.id && invoiceOptions && invoiceOptions.length === 0">
                <div class="col-md-4 label">
                    {{ 'bikeshop.modal.update_job_card.copy_items_from_master' | translate }}
                </div>
                <div class="col-md-8 value">
                    <p-checkbox [(ngModel)]="newQuoteOption.copyFromMaster" [binary]="true"></p-checkbox>
                </div>
            </div>

            <div class="row margin-top-16" *ngIf="!newQuoteOption.id && invoiceOptions && invoiceOptions.length > 0">
                <div class="col-md-4 label">
                    {{ 'bikeshop.modal.update_job_card.copy_items_from_option_option' | translate }}
                </div>
                <div class="col-md-8 value">
                    <p-dropdown [options]="copyOptions" [(ngModel)]="newQuoteOption.copyFromOption"
                        [showClear]="true"></p-dropdown>
                </div>
            </div>

            <div class="row margin-top-16" *ngIf="!newQuoteOption.id">
                <div class="col-md-3 value">
                    <hub-button [text]="'bikeshop.modal.update_job_card.cancel_quote_option' | translate"
                        [disabled]="busy" [style]="'outline'" [size]="'lg'"
                        (buttonClick)="cancelQuoteOption()"></hub-button>
                </div>
                <div class="col-md-6 label"></div>
                <div class="col-md-3 value">
                    <hub-button [text]="'bikeshop.modal.update_job_card.save_quote_option' | translate"
                        [disabled]="busy || newQuoteOption.optionName === null || newQuoteOption.optionName.length === 0"
                        [style]="'primary'" [size]="'lg'" (buttonClick)="addQuoteOption()"></hub-button>
                </div>
            </div>

            <div class="row margin-top-16" *ngIf="newQuoteOption.id">
                <div class="col-md-3 value">
                    <hub-button [text]="'bikeshop.modal.update_job_card.cancel_quote_option' | translate"
                        [disabled]="busy" [style]="'outline'" [size]="'lg'"
                        (buttonClick)="cancelQuoteOption()"></hub-button>
                </div>
                <div class="col-md-3 label"></div>
                <div class="col-md-3 value">
                    <hub-button [text]="'bikeshop.modal.update_job_card.delete_quote_option' | translate"
                        [disabled]="busy" [style]="'outline'" [size]="'lg'"
                        (buttonClick)="deleteQuoteOption(newQuoteOption)"></hub-button>
                </div>
                <div class="col-md-3 value">
                    <hub-button [text]="'bikeshop.modal.update_job_card.update_quote_option' | translate"
                        [disabled]="busy || newQuoteOption.optionName === null || newQuoteOption.optionName.length === 0"
                        [style]="'primary'" [size]="'lg'" (buttonClick)="updateQuoteOption()"></hub-button>
                </div>
            </div>
        </div>


        <div style="text-align: center;" *ngIf="busy && !showAddNew">
            <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
            </p-progressSpinner>
        </div>

        <p-accordion (onOpen)="onTabOpen($event)" (onClose)="onTabClose($event)" *ngIf="!showAddNew">
            <p-accordionTab *ngFor="let invoiceOption of invoiceOptions">
                <p-header>
                    <div class="accordion-tab">
                        <div class="status-indicator" [ngClass]="{
            'not-sent': invoiceOption.approvalStatus === 0,
            'sent': invoiceOption.approvalStatus === 1,
            'seen': invoiceOption.approvalStatus === 2,
            'approved': invoiceOption.approvalStatus === 10,
            'rejected': invoiceOption.approvalStatus === 9
          }"></div>
                        <div class="option-name">{{invoiceOption.optionName}}</div>
                        <div class="option-description">{{invoiceOption.optionDescription}}</div>
                        <div class="option-action"><span class="fa fa-pencil"
                                pTooltip="{{ 'bikeshop.modal.update_job_card.edit_delete_quote_option' | translate }}"
                                (click)="editQuoteOption(invoiceOption)"></span></div>
                    </div>
                </p-header>
                <div class="row">
                    <div class="col-7"></div>
                    <div class="col-5">
                        <div class="product-search" joyrideStep="quoteStepOne"
                            text="{{ 'bikeshop.tour.quote.step_one' | translate }}" *ngIf="canUpdate(invoiceOption)">
                            <p-autoComplete #productSearchComponent [(ngModel)]="productSearch" field="SKU"
                                [suggestions]="searchResult" [delay]="500" placeholder="{{
          'bikeshop.modal.update_job_card.quote.search_sku_or_other' | translate
        }}" (completeMethod)="searchProducts($event)" (onSelect)="addLineItemAuto($event)">
                                <ng-template let-product pTemplate="item">
                                    <div>
                                        <img *ngIf="product.ExternalProductID==''"
                                            src="https://www.bicycleretailer.com/sites/default/files/styles/colorbox_popup/public/images/article/qualitybicycleproducts_logo_vert_rgb.jpg?itok=A20lWGap"
                                            style="width:25px;display:inline-block;margin-right:5px;" />
                                        <span>{{ product.SKU }} - {{ product.Name }} {{product.UnitPrice ? (' - ' +
                                            partner.CurrencySymbol +
                                            (partner.VATInclusive ? (product.UnitPrice_IncludingTax | number: ".2-2") :
                                            (product.UnitPrice |
                                            number: ".2-2"))) : ''}}</span>
                                    </div>
                                </ng-template>
                            </p-autoComplete>
                            <span class="fa hubtiger-search"></span>
                        </div>
                    </div>
                </div>
                <div class="quote-table">
                    <div class="row header">
                        <div class="col-2">
                            {{ "bikeshop.modal.update_job_card.quote.sku" | translate }}
                        </div>
                        <div class="col-3"
                            *ngIf="partner.POSSystemID==3 || partner.POSSystemID==6 || partner.POSSystemID==9 ">
                            {{ "bikeshop.modal.update_job_card.quote.name" | translate }}
                        </div>
                        <div class="col-4"
                            *ngIf="partner.POSSystemID!=3 && partner.POSSystemID!=6 && partner.POSSystemID!=9 ">
                            {{ "bikeshop.modal.update_job_card.quote.name" | translate }}
                        </div>
                        <!--<div class="col-3">Description</div>-->
                        <!--<div class="col-1">Brand</div>-->
                        <div class="col-1 right" *ngIf="allowDiscount">
                            <span>
                                {{
                                "bikeshop.modal.update_job_card.quote.discount_abbr" | translate
                                }}
                            </span>
                        </div>
                        <div class="col-1 right" *ngIf="!allowDiscount"></div>
                        <div class="col-1 right">
                            {{ "bikeshop.modal.update_job_card.quote.qty" | translate }}
                        </div>
                        <div class="col-2 right" *ngIf="!VATInclusive">
                            {{ "bikeshop.modal.update_job_card.quote.unit_price" | translate }}
                        </div>
                        <div class="col-2 right" *ngIf="VATInclusive">
                            <span>
                                {{
                                "bikeshop.modal.update_job_card.quote.price_incl_vat" | translate
                                }}
                            </span>
                        </div>
                        <div class="col-2 actions" *ngIf="canUpdate(invoiceOption)">
                            <span class="fa fa-spinner fa-pulse" *ngIf="updatingQuote"
                                style="height: fit-content"></span>
                            <span joyrideStep="quoteStepTwo" style="padding-top: 5px;"
                                text="{{ 'bikeshop.tour.quote.step_one' | translate }}">
                                <span pTooltip="{{
                'bikeshop.modal.update_job_card.quote.pos_sync_tooltip' | translate
              }}" tooltipPosition="bottom" class="fa hubtiger-sync"
                                    style="margin-left: auto;margin-right: 8px;"></span>
                            </span>
                        </div>
                    </div>
                    <div *ngFor="let lineItem of invoiceOption.invoiceQuoteOptionLineItem; let i = index">
                        <div *ngIf="!lineItem.edit" class="row line-item">
                            <div class="col-2" style="display: flex;">
                                {{ lineItem.sku }}
                            </div>
                            <div class="col-3"
                                *ngIf="partner.POSSystemID==3 || partner.POSSystemID==6 || partner.POSSystemID==9 ">
                                {{
                                lineItem.name
                                }}
                            </div>
                            <div class="col-4"
                                *ngIf="partner.POSSystemID!=3 && partner.POSSystemID!=6 && partner.POSSystemID!=9 ">
                                {{
                                lineItem.name
                                }}
                            </div>

                            <!--<div class="col-3">{{lineItem.Description}}</div>-->
                            <!--<div class="col-1">{{lineItem.Brand}}</div>-->
                            <div class="col-1 right" *ngIf="allowDiscount">
                                {{ currencySymbol }}
                                {{ (lineItem.discount ? lineItem.discount : 0) | number: ".2-2" }}
                            </div>
                            <div class="col-1 right" *ngIf="!allowDiscount"></div>
                            <div class="col-1 right">
                                <span *ngIf="!canUpdate(invoiceOption)">{{ lineItem.quantity }}</span>
                                <p-inplace #qty (click)="lineItem.edit = true" *ngIf="canUpdate(invoiceOption)">
                                    <span pInplaceDisplay>
                                        {{ lineItem.quantity }}
                                    </span>
                                    <span pInplaceContent>
                                        <div class="p-inputgroup">
                                            <input type="number" min="0" pInputText [(ngModel)]="lineItem.quantity" #qty
                                                (keyup.enter)="updateLineItem(lineItem)" placeholder="{{
                        'bikeshop.modal.update_job_card.quote.qty' | translate
                      }}" />
                                        </div>
                                    </span>
                                </p-inplace>
                                <span>{{ lineItem.Quantity }}</span>
                            </div>
                            <div class="col-2 right" *ngIf="!VATInclusive">
                                {{ currencySymbol }} {{ lineItem.unitPrice | number: ".2-2" }}
                            </div>
                            <div class="col-2 right" *ngIf="VATInclusive">
                                <span *ngIf="VATInclusive">
                                    {{ currencySymbol }}
                                    {{ lineItem.unitPrice_IncludingTax | number: ".2-2" }}
                                </span>
                            </div>
                            <div class="col-2 actions">
                                <span class="fa fa-fw hubtiger-edit" (click)="lineItem.edit = true"
                                    *ngIf="canUpdate(invoiceOption) && !updatingQuote" title="Edit line item."></span>
                                <span class="fa fa-fw hubtiger-delete" (click)="deleteLineItem(lineItem)"
                                    *ngIf="canUpdate(invoiceOption) && !updatingQuote" title="{{
                  'bikeshop.modal.update_job_card.quote.delete_line_item_from_quote'
                    | translate
                }}"></span>
                                <span class="fa fa-fw"
                                    [ngClass]="{ 'hubtiger-sticky-note': lineItem.lineItemNote === undefined || lineItem.lineItemNote === null || lineItem.lineItemNote === '', 'hubtiger-sticky-note-text': lineItem.lineItemNote !== undefined && lineItem.lineItemNote !== null && lineItem.lineItemNote.length > 0 }"
                                    *ngIf="!updatingQuote"
                                    pTooltip="{{lineItem.lineItemNote === undefined || lineItem.lineItemNote === null || lineItem.lineItemNote === '' ? ('bikeshop.modal.update_job_card.quote.add_line_item_note' | translate) : lineItem.lineItemNote}}"
                                    tooltipPosition="bottom" (click)="lineItemNoteUpdate.toggle($event)"></span>

                                <div style="position: absolute;right: 430px;margin-top: 16px">
                                    <p-overlayPanel #lineItemNoteUpdate [dismissable]="false" [showCloseIcon]="true"
                                        (onShow)="productPanelVisible(lineItem)" (onHide)="productPanelHidden()">
                                        <div style="width: 400px;">
                                            <div class="overlay-title">
                                                {{
                                                'bikeshop.modal.update_job_card.quote.add_line_item_note' |
                                                translate
                                                }}
                                            </div>
                                            <div class="p-inputgroup">
                                                <textarea [rows]="5" pInputTextarea
                                                    [(ngModel)]="lineItem.lineItemNoteUpdate"></textarea>
                                            </div>
                                            <div style="display:flex;justify-content: flex-end;margin-top: 8px;">
                                                <button pButton type="button" class="p-button-raised"
                                                    (click)="updateLineItemNote(lineItem, lineItemNoteUpdate)"
                                                    label="{{'bikeshop.modal.update_job_card.quote.update_note'| translate}}"></button>
                                            </div>
                                        </div>
                                    </p-overlayPanel>
                                </div>

                            </div>
                        </div>
                        <div></div>
                        <div *ngIf="lineItem.edit" class="row line-item edit">
                            <div class="col-2">{{ lineItem.sku }}</div>
                            <div class="col-3">{{ lineItem.name }}</div>
                            <!--<div class="col-1">{{editLine.Brand}}</div>-->
                            <div class="col-1" *ngIf="allowDiscount" style="overflow:visible">
                                <div *ngIf="discountType === 'AMOUNT'">
                                    <input type="number" pInputText [(ngModel)]="lineItem.discount" />
                                </div>
                                <div class="p-inputgroup" *ngIf="discountType === 'PERCENTAGE'">
                                    <p-dropdown [options]="discounts" class="full-width"
                                        [(ngModel)]="lineItem.discountID"></p-dropdown>
                                </div>
                            </div>
                            <div class="col-1 right" *ngIf="!allowDiscount"></div>
                            <div class="col-1 right">
                                <input type="number" min="0" pInputText [(ngModel)]="lineItem.quantity"
                                    #quantityComponent (keyup.enter)="updateLineItem(lineItem)" placeholder="{{
                  'bikeshop.modal.update_job_card.quote.qty' | translate
                }}" />
                            </div>
                            <div class="col-2 right" style="overflow:visible">
                                <input *ngIf="VATInclusive" type="number" pInputText
                                    [(ngModel)]="lineItem.unitPrice_IncludingTax" placeholder="{{
                    'bikeshop.modal.update_job_card.quote.unit_price' | translate
                  }}" style="text-align: right; margin-right: -16px; padding-right: 25px;" />
                                <input *ngIf="!VATInclusive" type="number" pInputText [(ngModel)]="lineItem.unitPrice"
                                    placeholder="{{
                    'bikeshop.modal.update_job_card.quote.unit_price' | translate
                  }}" style="text-align: right; margin-right: -16px; padding-right: 25px;" />
                            </div>
                            <div class="col-2 actions">
                                <span class="save" *ngIf="lineItem.unitPrice >= 0 && !updatingQuote"
                                    (click)="updateLineItem(lineItem)">{{
                                    "bikeshop.general.save" |
                                    translate }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="totals">
                        <div class="row" *ngIf="allowDiscount">
                            <div class="col-5"></div>
                            <div class="col-2 right">
                                {{ "bikeshop.modal.update_job_card.quote.discount" | translate }}:
                            </div>
                            <div class="col-2 right">
                                {{ currencySymbol }}
                                {{ invoiceOption.total_Discounts | number: ".2-2" }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-5"></div>
                            <div class="col-2 right">
                                {{ "bikeshop.modal.update_job_card.quote.sub-total" | translate }}:
                            </div>
                            <div class="col-2 right">
                                {{ currencySymbol }}
                                {{ invoiceOption.total_LineItems | number: ".2-2" }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-5"></div>
                            <div class="col-2 right">
                                {{ "bikeshop.modal.update_job_card.quote.vat" | translate }}:
                            </div>
                            <div class="col-2 right">
                                {{ currencySymbol }} {{ invoiceOption.total_Tax | number: ".2-2" }}
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-5"></div>
                            <div class="col-2 right">
                                {{ "bikeshop.modal.update_job_card.quote.total" | translate }}:
                            </div>
                            <div class="col-2 right">
                                {{ currencySymbol }}
                                {{ invoiceOption.total_Price | number: ".2-2" }}
                            </div>
                        </div>
                    </div>

                </div>
            </p-accordionTab>
        </p-accordion>

        <div *ngIf="!showAddNew && canSendQuoteOptions() && invoiceOptions.length === 1" class="need-more-options">
            {{ 'bikeshop.modal.update_job_card.more_options_needed_to_send' | translate }}
        </div>

        <div class="ledgend-container margin-top-16" *ngIf="!showAddNew && invoiceOptions && invoiceOptions.length > 0">
            <div>
                <div class="status-legend">
                    <div>
                        <div class="status-indicator not-sent"></div>
                        {{ 'bikeshop.modal.update_job_card.not_sent' | translate }}
                    </div>
                    <div>
                        <div class="status-indicator sent"></div>
                        {{ 'bikeshop.modal.update_job_card.sent' | translate }}
                    </div>
                    <div>
                        <div class="status-indicator seen"></div>
                        {{ 'bikeshop.modal.update_job_card.seen' | translate }}
                    </div>
                    <div>
                        <div class="status-indicator approved"></div>
                        {{ 'bikeshop.modal.update_job_card.approved' | translate }}
                    </div>
                    <div>
                        <div class="status-indicator rejected"></div>
                        {{ 'bikeshop.modal.update_job_card.rejected' | translate }}
                    </div>
                </div>
            </div>
            <div>
                <div *ngIf="jobcard.thirdPartyID != null" style="display: flex;align-items: center;">
                    <p-inputSwitch [(ngModel)]="sendToThirdPartyOnly"></p-inputSwitch>
                    <small style="margin-left: 16px;">{{ "bikeshop.modal.update_job_card.quote.send_quote_to_third_party_only"
                        | translate }}</small>
                </div>
                <hub-button [text]="'bikeshop.modal.update_job_card.send_quote_options' | translate"
                    [disabled]="busy || !templateActive || !canSendQuoteOptions() || invoiceOptions.length === 1"
                    [loading]="busy" [style]="'primary'" [size]="'lg'" (buttonClick)="sendQuoteOptions()"></hub-button>
            </div>
        </div>

        <div class="no-active-message-template" *ngIf="!busy && !templateActive">
            <span>{{ 'bikeshop.modal.update_job_card.message_template_not_active' | translate }}</span>
            <hub-button [text]="'bikeshop.modal.update_job_card.manage_message_templates' | translate"
                [style]="'primary'" [size]="'md'" (buttonClick)="goToMessageTemplates()"></hub-button>
        </div>

    </div>


</div>
<div class="modal-footer-container">
    <div class="button-container">

    </div>
</div>

<p-confirmDialog key="quote-option"></p-confirmDialog>